<template>
  <div id="login">
    <div class="logo">
      <img src="../../static/newLogoImg/logo.png" alt="">
    </div>
    <div class="login-box">
      <div class="login-banner-box" ref="bannerBox">
        <ul class="banner-box"
            :style="{transform: `translateX(-${activeId*Uwidth}px)`,width:Uwidth*((bannerList&&bannerList.length)?bannerList.length:1)+'px'}">
          <li class="banner-item" v-for="(banner,bannerIndex) in bannerList" :key="bannerIndex"
              :style="{width:Uwidth+'px'}">
            <img :src="banner.url" alt="">
          </li>
        </ul>
        <ul class="banner-toggle-box">
          <li class="banner-toggle-btn" v-for="(banner,bannerIndex) in bannerList"
              :class="{'active':activeId === bannerIndex}" @click="activeBanner(banner,bannerIndex)"></li>
        </ul>
      </div>
      <div class="login-right-box">
        <h3 class="login-title">登录</h3>
        <ul class="login-nab flex-box">
          <li @click="activeNab = 1;getImgCode()" :class="activeNab == 1? 'select-nab':''">手机号登录</li>
          <li @click="activeNab = 2;getImgCode()" :class="activeNab == 2? 'select-nab':''">账号密码登录</li>
        </ul>
        <el-form :model="loginInfo" :rules="rules" ref="loginInfo" label-position="left" label-width="0px"
                 class="login-container" v-if="activeNab == 1">
          <el-form-item prop="phone">
            <div class="f-input-box">
              <div class="wh100 flex-box">
                <input maxlength="20" type="text" v-model="loginInfo.phone" @focus="adminBlur(1)"
                       @blur="adminBlur(2)" class="input_inner" @keyup.enter="handleSubmit" placeholder="手机号"/>
              </div>
              <div class="f-line-box">
                <span v-if="!adminState" class="line"></span>
                <span class="focus-line" :style="{ transform: 'scaleX('+adminDeg+')'}"></span>
              </div>
            </div>
          </el-form-item>
					<el-form-item prop="code">
						<div class="f-input-box">
							<div class="f-input-box">
								<div class="wh100 flex-box">
									<input maxlength="10" type="text" v-model="loginInfo.captchaValue" @focus="imgBlur(1)"
                       @blur="imgBlur(2)" class="input_inner" @keyup.enter="handleSubmit" placeholder="图形验证码"/>
								</div>
								<div class="f-line-box">
									<span v-if="!imgDeg" class="line"></span>
									<span class="focus-line" :style="{ transform: 'scaleX('+imgDeg+')'}"></span>
								</div>
							</div>
							<img
								class="g-pass-btn"
								v-if="imgCode"
								:src="imgCode"
								alt=""
								style="height: 34px;margin-left: 10px;width: auto;"
								@click="getImgCode"
							/>
						</div>
					</el-form-item>
          <el-form-item prop="phoneCode">
            <div class="f-input-box" style="margin-top: 10px;">
              <div class="wh100 flex-box">
                <input type="text" v-model="loginInfo.phoneCode" @focus="passwordBlur(1)"
                       @blur="passwordBlur(2)"
                       class="input_inner" placeholder="请输入验证码" @keyup.enter="handleSubmit"/>
              </div>
              <div class="f-line-box">
                <span v-if="!passwordState" class="line"></span>
                <span class="focus-line" :style="{transform:'scaleX('+passwordDeg+')'}"></span>
              </div>
              <el-button type="primary" class="g-pass-btn" v-if="!getCoding" @click.stop="getCode">获取验证码</el-button>
              <el-button type="primary" class="g-pass-btn" v-else disable>剩余{{resend}}s</el-button>
            </div>
            <div class="text-right" style="margin-top: 10px;">
            </div>
          </el-form-item>
        </el-form>
        <el-form :model="loginInfo" :rules="rules" ref="loginInfo" label-position="left" label-width="0px"
                 class="login-container" v-if="activeNab == 2">
          <el-form-item prop="mhManagerAccount">
            <div class="f-input-box">
              <div class="wh100 flex-box">
                <img src="../assets/img/icon_account.png" alt="">
                <input maxlength="20" type="text" v-model="loginInfo.mhManagerAccount" @focus="adminBlur(1)"
                       @blur="adminBlur(2)" class="input_inner" @keyup.enter="handleSubmit" placeholder="请输入账号"/>
              </div>
              <div class="f-line-box">
                <span v-if="!adminState" class="line"></span>
                <span class="focus-line" :style="{ transform: 'scaleX('+adminDeg+')'}"></span>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="mhManagerPassword">
            <div class="f-input-box" style="margin-top: 10px;">
              <div class="wh100 flex-box">
                <img src="../assets/img/icon_password.png" alt="">
                <input type="password" v-model="loginInfo.mhManagerPassword" @focus="passwordBlur(1)"
                       @blur="passwordBlur(2)"
                       class="input_inner" placeholder="请输入密码" @keyup.enter="handleSubmit"/>
              </div>
              <div class="f-line-box">
                <span v-if="!passwordState" class="line"></span>
                <span class="focus-line" :style="{transform:'scaleX('+passwordDeg+')'}"></span>
              </div>
            </div>
            <div class="text-right" style="margin-top: 10px;">
            </div>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="f-login-btn" @click.native.prevent="handleSubmit"
                    :loading="logining">登录
        </el-button>
        <div class="forget-password-box">
          <span>若您缺少或遗忘账号信息，请及时联系管理员获取</span>
        </div>
      </div>
    </div>
    <el-dialog title="请选择登录企业" class="append-body" :visible.sync="chooseCompanyDialog" :append-to-body="true"
               width="700px" center top="3%">
      <v-switch-company v-if="chooseCompanyDialog" :companyIcList="companyIcList"
                     @closeDialog="chooseCompanyDialog=false;$router.push('/workbench');"
                     ></v-switch-company>
    </el-dialog>
    <!-- <v-switch-company v-if="$store.state.switchCompanyDialog"></v-switch-company> -->
  </div>
</template>

<script>
  import * as getData from '../service/getData';
  import {ossUrl} from '../config/env';
  import SM4Util from '../config/sm4'

  export default {
    data() {
      let isAccountCorrect = (rule, value, callback) => {
        const myReg = /^\S+$/;
        if (!value) {
          return callback(new Error('账号不能为空！'))
        }
        if (!myReg.test(value)) {
          return callback(new Error('账号不能包含空白字符！'))
        } else {
          callback()
        }
      };
      let isTypeCorrect = (rule, value, callback) => {
        const myReg = /^\S+$/;
        if (!value) {
          return callback(new Error('密码不能为空！'))
        }
        if (!myReg.test(value)) {
          return callback(new Error('密码不能包含空白字符！'))
        } else {
          callback()
        }
      };
      return {
        logining: false,
        adminState: false,
        passwordState: false,
        imgState: false,
				imgDeg:0,
        adminDeg: 0,
        passwordDeg: 0,
        loginInfo: {
          phone: '',
					captchaValue:'',
          phoneCode: '',
          mhManagerAccount: '',
          mhManagerPassword: '',
        },
        channelId: '',
        rules: {
          phone: [
            {required: true, message: '请输入手机号', trigger: ['blur', 'change']},
            {pattern: global.phoneRule, message: '手机号格式错误'}
          ],
          phoneCode: [
            { required: true, message: "请输入验证码", trigger: "blur" }
          ],
          mhManagerAccount: [
            {required: true, validator: isAccountCorrect, trigger: 'blur'},
          ],
          mhManagerPassword: [
            {required: true, validator: isTypeCorrect, trigger: 'blur'},
          ]
        },
        checked: true,
        domain: '',
        bannerList: [
          {
            url: '../../static/newLogoImg/banner1.png'
          },
          {
            url: '../../static/newLogoImg/banner2.png'
          },
          {
            url: '../../static/newLogoImg/banner3.png'
          },
        ],
        activeId: 0,
        Uwidth: 440,
        sendCodeTime: null,
        resend: 180,
        getCoding: false,
        companyIcList: [],
        chooseCompanyDialog:false,
        activeNab: 1,
				imgCode:'',
				captchaKey:'',
      };
    },
    beforeCreate() {
      sessionStorage.clear();
      localStorage.clear();
    },
    mounted() {
			this.getImgCode()
      getData.getChannelIdByUrl(ossUrl+'/').then(res => {
        sessionStorage.setItem('channelId', res.data.channelId);
        // sessionStorage.setItem('companyId', res.data.companyId);
        sessionStorage.setItem('logoUrl',res.data.channelLogoUrl);
        sessionStorage.setItem('channelMortarBackUrl',res.data.channelMortarBackUrl);
        this.channelId = res.data.channelId
      });
      let bannerBox = this.$refs.bannerBox;
      if (!bannerBox || !bannerBox.offsetWidth) {
        return
      }
      this.Uwidth = bannerBox.offsetWidth;
      this.setBannerTimeOut();
    },
    methods: {
			getImgCode(){
				getData.mhManagergCaptcha().then(res=>{
					this.imgCode = res.data.data.imageData
					this.captchaKey = res.data.data.captchaKey
				})
			},
      activeBanner(row, index) {
        this.activeId = index;
        this.setBannerTimeOut();
      },
      setBannerTimeOut() {
        if (this.bannerTimeOut) {
          clearTimeout(this.bannerTimeOut)
        }
        this.bannerTimeOut = setTimeout(() => {
          this.activeId += 1;
          if (this.activeId >= 2) {
            this.activeId = 0;
          }
          this.setBannerTimeOut();
        }, 5000)
      },
      adminBlur(type) {
        if (type == 1) {
          this.adminState = true;
          this.adminDeg = 1;
        } else {
          this.adminState = false;
          this.adminDeg = 0;
        }
      },
			imgBlur(type) {
				if (type == 1) {
					this.imgState = true;
					this.imgDeg = 1;
				} else {
					this.imgState = false;
					this.imgDeg = 0;
				}
			},
      passwordBlur(type) {
        if (type == 1) {
          this.passwordState = true;
          this.passwordDeg = 1;
        } else {
          this.passwordState = false;
          this.passwordDeg = 0;
        }
      },
      addMouseFun() {
      },
      handleSubmit(ev) {
				if(!this.channelId){
          this.$router.go(0);
          this.$message({message: '登录失败',type: 'warning'});
          return
        }
        if ((!this.loginInfo.phone || !this.loginInfo.phoneCode)&&this.activeNab == 1) {
          return
        }
        if ((!this.loginInfo.mhManagerAccount || !this.loginInfo.mhManagerPassword)&&this.activeNab == 2) {
          return
        }
        this.$refs.loginInfo.validate((valid) => {
          if (valid) {
            this.logining = true;
            let data = {};
            if(this.activeNab == 1){
              data = {
                mhManagerChannelId: this.channelId,
                phone: this.loginInfo.phone,
                phoneCode: this.loginInfo.phoneCode,
              }
            }else if(this.activeNab == 2){
              const sm4 = new SM4Util('qawsedrftgyhujik')
              data = {
                mhManagerChannelId: this.channelId,
                mhManagerAccount: encodeURIComponent(sm4.encryptData_ECB(this.loginInfo.mhManagerAccount)),
                mhManagerPassword: encodeURIComponent(sm4.encryptData_ECB(this.loginInfo.mhManagerPassword)),
                flag: 2,
              }
            }
            getData.login(data).then(res => {
              this.logining = false;
              if (res.data.code == 'success') {
                this.$message({
                  message: '登录成功',
                  type: 'success'
                });
                //sessionStorage.setItem('logoUrl', res.data.data.logoUrl);
                sessionStorage.setItem('permissions', JSON.stringify(res.data.data.permissions));
                sessionStorage.setItem('allSessionId', res.data.data.allSessionId);
								sessionStorage.setItem('companyId', res.data.data.companyId)
                this.userCompanyList();
              } else {
                this.$message({
                  message: res.data.message,
                  type: 'warning'
                });
              }
            }).catch(_ => {
              this.$message.warning('登录失败！');
              this.logining = false;
            })
          } else {
            console.log('error submit!!');
            this.logining = false;
            return false;
          }
        });
      },
      userCompanyList() {//获取账号归属公司
        getData.userCompanyList().then((res) => {
          if (res.data.code != 1) {
            return
          }
          this.companyIcList = res.data.data;
          if(this.companyIcList.length > 1){
            this.chooseCompanyDialog = true;
            this.$store.state.showSwitchCompany = true;
          }else{
            this.$router.push('/workbench');
          }
        }).catch(_ => {
        })
      },
      getCode() {//发送验证码
        if (this.getCoding) {
          return
        }
        if (!this.loginInfo.phone) {
          this.$message.warning('请输入手机号码!')
          } else if(!this.loginInfo.captchaValue){
						this.$message.warning('请输入图形验证码!')
					}else {
            this.getCoding = true;
            this.sendPhoneMsg();
        }
      },
      sendPhoneMsg() {
        getData.sendCodeMsg({phone: this.loginInfo.phone,type:2,codeState:0,channelId:this.channelId,captchaKey:this.captchaKey,captchaValue:this.loginInfo.captchaValue}).then((res) => {
          if (res.data.code != 'success') {
            this.$message.error(res.data.message || res.data.Msg);
            this.getCoding = false;
            return
          }
          this.resendCode();
          this.$message.success('验证码发送成功，请注意查收！');
        }).catch(_ => {
          this.$message.warning('验证码获取失败！');
          this.getCoding = false;
        })
      },
      resendCode() {
        if (this.sendCodeTime) {
          clearTimeout(this.sendCodeTime)
        }
        this.sendCodeTime = setTimeout(() => {
          if (this.resend <= 0) {
            this.resend = 180;
            this.getCoding = false;
            return
          }
          this.resend--;
          this.resendCode();
        }, 1000)
      },
    }
  }
</script>
<style lang="scss" scoped>
  .page-container {
    font-size: 20px;
    text-align: center;
    color: rgb(192, 204, 218);
  }

  #login {
    width: 100%;
    height: 100%;
    display: flex;
    background: url("../../static/newLogoImg/bg.png") no-repeat;
    background-size: 100% 100%;
    background-origin: content-box;
    position: relative;

    .logo {
      position: absolute;
      width: 13.02%;
      height: auto;
      top: 3.02%;
      left: 4.27%;

      > img {
        width: 100%;
        height: auto;
      }
    }

    .login-box {
      /*width: 52.08%;*/
      /*height: 51.85%;*/
      width: 1000px;
      height: 560px;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 12px 0 rgba(0, 14, 55, 0.1);
      border-radius: 10px;
      display: flex;
      overflow: hidden;

      .login-banner-box {
        /*width: 44%;*/
        width: 440px;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;

        > .banner-box {
          min-width: 300%;
          display: flex;
          transition: all .6s ease-in-out;

          .banner-item {
            width: 440px;
            height: 100%;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;

            > img {
              width: 100%;
              height: 100%;
              border-top-left-radius: 10px;
              border-bottom-left-radius: 10px;
            }
          }
        }

        .banner-box.active1 {
          transform: translateX(-0px);
        }

        .banner-box.active2 {
          transform: translateX(-440px);
        }

        .banner-box.active3 {
          transform: translateX(-880px);
        }

        .banner-toggle-box {
          position: absolute;
          width: 100%;
          bottom: 22px;
          min-height: 4px;
          display: flex;
          justify-content: center;

          .banner-toggle-btn {
            width: 18px;
            height: 4px;
            background: rgba(255, 255, 255, .2);
            margin-left: 7px;
            border-radius: 2px;
            cursor: pointer;
            transition: all .6s ease-in-out;
          }

          .banner-toggle-btn:first-child {
            margin-left: 0;
          }

          .banner-toggle-btn.active {
            background: rgba(255, 255, 255, 1);
          }
        }
      }

      .login-right-box {
        /*width: 56%;*/
        width: 560px;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        padding: 94px 120px;

        .login-title {
          font-size: 34px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(0, 114, 255, 1);
          text-align: center;
        }
      }

      .login-container {
        margin-top: 35px;
      }

      .f-login-btn {
        width: 100%;
        height: 48px;
        background: rgba(0, 114, 255, .8);
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
        line-height: 36px;
        padding: 0 15px;
        box-sizing: border-box;
        margin-top: 10px;
        border-radius: 4px;
        box-shadow: 0px 7px 25px -4px  rgba(0, 114, 255, 0.8);
      }

      .forget-password-box {
        width: 100%;
        margin-top: 10px;
        text-align: right;

        > span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 42px;
        }
      }
    }
  }
	.code_content {
		display: flex;
	}
	.icon_box {
		display: flex;
		align-items: center;
		// display: flex;
		i{
			font-size: 22px;
			color: #878987;
			margin-left: 3px;
		}
	}
  .login-nab{
    margin-top: 55px;
    padding: 0 10px;
    border-bottom: 1px solid #D8D8D8;
    justify-content: space-around;
    font-size: 18px;
    font-weight: 400;
    li{
      text-align: center;
      border-bottom: 4px solid rgba(255, 255, 255, 0);
      color: #333333;
      /* margin-left: 20px; */
      padding: 10px 0;
      cursor: pointer;
      font-size: 16px;
      /* p {
        font-weight: 700;
        font-style: normal;
        font-size: 18px;
      } */
    }
    /* li:hover {
      border-bottom: 4px solid #0066FF;
      color: #0066FF;
    } */
    .select-nab {
      font-size: 18px;
      font-weight: 600;
      color: #4599F1;
      border-bottom: 4px solid #4599F1;
    }
  }
  .f-input-box {
    position: relative;
    height: 32px;
    img{
      width: 25px;
      height: 25px;
    }
    .g-pass-btn{
      position: absolute;
      right: 0;
      top: 20%;
      margin-top: -10px;
      width: 91px;
      height: 33px;
      /* background: #0fc8fc; */
      border-radius: 2px;
      color: #ffffff;
      padding: 0;
      text-align: center;
      /* border-color: #0fc8fc; */
    }

    .icon {
      font-size: 22px;
      color: #7b7b7b;
      line-height: 32px;
    }

    .input_inner {
      border: 0;
      flex: 1;
      width: 100%;
      height: 100%;
      padding: 5px 10px;
      box-sizing: border-box;
      /*font-size: 20px;*/
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #999999;
    }

    .input_inner::-webkit-input-placeholder, .input_inner:-moz-placeholder, .input_inner::-moz-placeholder, .input_inner:-ms-input-placeholder {
      color: #999;
    }

    .f-line-box {
      height: 1px;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: center;

      span {
        display: block;
        width: 0;
        height: 1px;
        background: #D8D8D8;
      }

      .line {
        width: 100%;
      }

      .focus-line {
        width: 100%;
        background: #2878FF;
        margin: -1px 0 0;
        height: 2px;
        border: none;
        position: absolute;
        left: 0;
        right: 0;
        -webkit-transform: scaleX(0);
        -ms-transform: scaleX(0);
        transform: scaleX(0);
        transition: transform .45s cubic-bezier(.23, 1, .32, 1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/newLogin.vue